import styled, { css } from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const Container = styled.div<{ isOpen: boolean }>`
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  color: ${TextColorNames.tertiary};
  font-family: inherit;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow: hidden;
  display: inline-block;
  position: relative;

  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  strong {
    font-weight: 500;
  }
`;

export const ShowMoreBtn = styled.span`
  bottom: 0;
  font-size: 15px;
  font-weight: 300;
  white-space: nowrap;
  text-decoration: underline;
  color: ${TextColorNames.tertiary};
  font-style: italic;
  position: absolute;
  top: 18px;
  right: 0;
  background: #fafafa; /* white background to cover the text behind */
  box-shadow: -6px 0 4px -3px rgba(250, 250, 250, 1);
  padding: 0 3px 2px;
`;

export const ShowLessBtn = styled.span`
  margin-left: 5px;
  font-size: 15px;
  font-weight: 300;
  white-space: nowrap;
  text-decoration: underline;
  color: ${TextColorNames.tertiary};
  font-style: italic;
`;

export const HiddenSample = styled.div`
  font-weight: 300;
  font-size: 15px;
  line-height: 21px;
  color: ${TextColorNames.tertiary};
  font-family: inherit;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow: hidden;
  display: inline-block;
  position: absolute;
  bottom: 0px;
  z-index: -1;

  strong {
    font-weight: 500;
  }
`;
